(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    // Sticky ATC — shows on mobile after scrolling past the main ATC button
    var sectionId = document.currentScript
      ? document.currentScript.closest('[data-section]') && document.currentScript.closest('[data-section]').dataset.section
      : null;

    document.addEventListener('DOMContentLoaded', function () {
      var atcBars = document.querySelectorAll('.liumer-sticky-atc');
      atcBars.forEach(function (bar) {
        var stickyBtn = bar.querySelector('.liumer-sticky-atc__btn');
        var stickyPrice = bar.querySelector('.liumer-sticky-atc__price');
        var section = bar.closest('product-info');
        if (!section) return;

        // Find the main ATC button in this product section
        var mainAtcBtn = section.querySelector('.product-form__submit');
        if (!mainAtcBtn) return;

        // Show/hide based on scroll position relative to main ATC button
        function onScroll() {
          if (window.innerWidth >= 750) return; // mobile only
          var rect = mainAtcBtn.getBoundingClientRect();
          var pastButton = rect.bottom < 0;
          if (pastButton) {
            bar.classList.add('is-visible');
            bar.removeAttribute('aria-hidden');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        }

        // Update sticky price when variant changes
        var priceEl = section.querySelector('[id^="price-"]');
        if (priceEl && stickyPrice) {
          var priceObserver = new MutationObserver(function () {
            var currentPriceEl = priceEl.querySelector('.price-item--regular') || priceEl.querySelector('.price-item');
            if (currentPriceEl) {
              stickyPrice.textContent = currentPriceEl.textContent.trim();
            }
          });
          priceObserver.observe(priceEl, { childList: true, subtree: true });
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // run on load

        // Sticky ATC button click: submit main product form
        if (stickyBtn) {
          stickyBtn.addEventListener('click', function () {
            var mainForm = section.querySelector('form[data-type="add-to-cart-form"]');
            if (!mainForm) return;
            stickyBtn.classList.add('loading');
            stickyBtn.textContent = '\u2026';
            fetch('/cart/add.js', {
              method: 'POST',
              body: new FormData(mainForm)
            }).then(function (res) {
              if (!res.ok) throw new Error('Cart add failed');
              // Trigger Dawn's cart notification / drawer update
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              stickyBtn.classList.remove('loading');
              stickyBtn.textContent = 'Added \u2713';
              setTimeout(function () {
                stickyBtn.textContent = 'Add to Cart';
              }, 2000);
            }).catch(function () {
              stickyBtn.classList.remove('loading');
              stickyBtn.textContent = 'Add to Cart';
            });
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
